/**
 * Feature Flags Configuration
 * 
 * Centralized feature flag management for the application.
 * Flags can be controlled via environment variables or defaults.
 */

// Survey Modal Feature Flag
// Can be disabled by setting REACT_APP_SURVEY_MODAL_ENABLED=false in environment
const SURVEY_MODAL_ENABLED = process.env.REACT_APP_SURVEY_MODAL_ENABLED !== 'false';

// Export all feature flags
export const FEATURE_FLAGS = {
  // Survey modal after waitlist signup
  SURVEY_MODAL_ENABLED,
  
  // Add more feature flags here as needed
  // Example: ANALYTICS_ENABLED: process.env.REACT_APP_ANALYTICS_ENABLED !== 'false',
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] === true;
};

// Log feature flags in development
if (process.env.NODE_ENV === 'development') {
  console.log('Feature Flags:', FEATURE_FLAGS);
}

export default FEATURE_FLAGS;
